import * as Sentry from "@sentry/react"

Sentry.init({
    dsn: "https://35bb1db6b5f5848a1c17698f0384adf6@o4509762474344448.ingest.de.sentry.io/4509762475393104",
    sendDefaultPii: true,
    environment: process.env.NODE_ENV
})